import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { useEffect } from 'react';
import { Flex } from '@stepstone-genesis/components';
import { LeftSideContent } from './components/LeftSideContent.js';
import { RightSideContent } from './components/RightSideContent.js';
import { navigationActions } from '../../core/navigation/navigationSlice.js';
import { FORM_TYPES } from '../../forms.js';
import { useAppDispatch } from '../../hooks/redux/index.js';
export const FullscreenTwoStepContent = () => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(navigationActions.setActiveForm(FORM_TYPES.FULLSCREEN_TWO_STEP));
    }, []);
    return (_jsxs(Flex, { px: ['spaceS', 'spaceL'], py: ['spaceS2', 'spaceL'], sx: { overflowY: 'auto' }, flxDirection: ['column', 'row'], flxItems: 'stretch', gap: ['unset', 'spaceS'], children: [_jsx(LeftSideContent, {}), _jsx(RightSideContent, {})] }));
};
//# sourceMappingURL=FullscreenTwoStepContent.js.map